export class SystemLicensesController {
    constructor(XRayUIPermissions, $scope, JFrogTableViewOptions, JFrogModal, xrayLicensesDao,$rootScope) {
        this.$scope = $scope;
        $rootScope.h1Header='Manage Licenses';
        this.modal = JFrogModal;
        this.XRayUIPermissions = XRayUIPermissions;
        this.TemplateGenerator = JFrogTableViewOptions.cellTemplateGenerators;
        this.tableViewOptions = new JFrogTableViewOptions($scope);
        this.listTableViewOptions = new JFrogTableViewOptions($scope);
        this.xrayLicensesDao = xrayLicensesDao;
        this.createGrid()
        this.getLicenses();
        $scope.$on('$destroy', () => {
            $rootScope.h1Header='';
        })
    }

    createGrid() {
        this.tableViewOptions.setId('licenses-table')
            .setObjectName('License')
            .setColumns(this.getColumns())
            .setRowsPerPage(20)


        this.tableViewOptions.ctrl = this;
        const isAdmin = window.store.getters["common/context/GET_IS_ADMIN"];
        if (isAdmin) {
            this.tableViewOptions.setNewEntityAction(() => {
                this.addLicense();
                this.tableViewOptions.update();
            });

        }

        this.tableViewOptions.newEntityCustomText = 'New License';
    }


    getColumns() {
        return [
            {
                "header": "Name",
                "field": "name",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{row.entity.name}}</div>`,
                "filterable": true,
                "width": "33%"
            },
            {
                "header": "Full Name",
                "field": "type",
                'cellTemplate': `<div class="{{row.entity.priority}}">{{row.entity.full_name}}</div>`,
                "filterable": true,
                "width": "34%"
            },
            {
                "header": "References",
                "field": "author",
                "cellTemplate": `<div  class="jf-link"><a ng-click="grid.appScope.SystemLic.showReferences(row.entity)" class="jf-link">Show References ({{row.entity.references.length}})</a></div>`,
                "pixelWidthThreshold": 200,
                "width": "33%"
            }
        ]
    }

    showReferences(row) {

        if (row.references.length == 0) {
            return;
        }
        let refObjArr = [];
        let tmpObj;
        console.log("This is the references", row)

        _.each(row.references, (val, key) => {
            tmpObj = {};
            if (val == "") {
                return;
            }
            if (val.split("://").length) {
                tmpObj.sourceName = val.split("://")[1].trim().split(".")[0]

                if (tmpObj.sourceName == "www") {
                    tmpObj.sourceName = val.split("://")[1].trim().split(".")[1]
                }
            }
            tmpObj.sourceUrl = val

            refObjArr.push(tmpObj)
        })
        console.log("*****", refObjArr)

        let modalScope = this.$scope.$new();

        this.listTableViewOptions.setId('watch-targets-table')
            .setObjectName('Reference')
            .setColumns(this.getReferencesCols())
            .setRowsPerPage(8)

        this.listTableViewOptions.setData(refObjArr);
        modalScope.modalTitle = `'${row.name}' License References `
        modalScope.tableOptions = this.listTableViewOptions;

        this.modal.launchModalWithTemplateMarkup(require('../../../../modal_templates/show_list_grid_modal.html'), modalScope).result.then(() => {
        });

    }

    getReferencesCols() {

        return [
            {
                "header": "Source",
                "field": "sourceName",
                'cellTemplate': `<div class="ui-grid-cell-contents" >{{row.entity.sourceName}}</div>`,
                "filterable": true,
                "width": "50%"
            },
            {
                "header": "URL",
                "field": "sourceUrl",
                'cellTemplate': `<div class="ui-grid-cell-contents" > <a href="{{row.entity.sourceUrl}}" target="_blank">{{row.entity.sourceUrl }}</a></div>`,
                "filterable": true,
                "width": "50%"
            }

        ]
    }

    getActions() {
        return [
            {
                icon: 'icon icon-view',
                tooltip: 'More Info',
                callback: (row) => {
                    console.log("More info clicked")
                }

            }
        ];
    }


    addLicense() {
        console.log("Add New License");
        let modalScope = this.$scope.$new();
        let options = {windowClass: 'add-lic-modal'};
        modalScope.license = {};

        this.modal.launchModalWithTemplateMarkup(require('../../../../modal_templates/add_new_license_modal.html'), modalScope, 'lg', true, options).result.then((response) => {
            if ( !response.references || response.references[0] == "") {
                response.references = [];
            }
            this.tableViewOptions.update();
            this.xrayLicensesDao.setLicense(response).$promise.then((data) => {
                console.log("need to re-fetch the licenses")
                console.log("The returned data is",data)
                this.getLicenses();
            });
        });
    }

    getLicenses() {
        this.xrayLicensesDao.getNames().$promise.then((data) => {
            this.licenses = data;
            let unKnownIndex = _.findIndex(data, {name: "Unknown"})
            data.splice(unKnownIndex, 1)

            _.each(data, (val, key) => {

                if ( !val.references || val.references[0] == "") {
                    val.references = [];
                }
            })
            this.tableViewOptions.setData(this.licenses);
        });
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/system_licenses/system_licenses.controller.js